import { Injectable } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions/';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth'
import { userInfo } from 'os';

@Injectable({
  providedIn: 'root'
})
export class UserPanelService {
  public subjectName = null;
  public clipName = null;
  constructor(
    private fsFuncs: AngularFireFunctions,
    private http: HttpClient,
    private auth: AngularFireAuth
  ) {
    auth.onAuthStateChanged(async (userInfo) => {
    })
  }
  getClips(subjectName: string) {
    if(subjectName=="Projektovanje softvera - C#") subjectName = "Projektovanje softvera - C Sharp"
    return new Promise(async (resolve, reject) => {
      var user = await this.auth.currentUser;
      this.http.get('https://us-central1-binarybioskop-1551559206895.cloudfunctions.net/getClips', {
        headers: {
          "Authorization": `Bearer ${await user.getIdToken()}`
        },
        params: {
          subjectName: subjectName
        }
      })
        .subscribe((data) => {
          resolve(data)
        })
    })
  }
  getSignatures(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let subjectName = this.subjectName;
      if(subjectName=="Projektovanje softvera - C#") subjectName = "Projektovanje softvera - C Sharp"
      var user = await this.auth.currentUser;
      this.fsFuncs.httpsCallable('getSignatures')({
        sname:subjectName,
        cname:this.clipName
      }).subscribe((data)=>{
        resolve(data);
      })
    })
  }

}